import Swiper from './Swiper';
import { mergeSettings, writeNavigationButtons, writePagination } from './Functions';
import isLive from 'DistributionPackages/GesagtGetan.Basic/Resources/Private/Assets/Variables/isLive';

const type = {
    image(slider, settings, nummberOfSlides) {
        let multipleSlides = nummberOfSlides > 1;        
    

        let options = mergeSettings({
            typeSettings: {
                autoplay: {
                    enabled: multipleSlides && isLive,
                    delay: 6000
                },
                lazy: {
                    enabled: true,
                    loadPrevNext: true
                },
            
            
                on: {
                    reachEnd: function() {
                        // Stop autoplay on the first slide after all slides were shown
                        this.autoplay.stop();
                    }
                },
                loop: multipleSlides,
                speed: 1500,
                preloadImages: false
            },
            settings,
            nummberOfSlides
        });
        new Swiper(slider, options);
    },
    quotes(slider, settings, nummberOfSlides) {
        function randomizeOrder(elements) {
            if (!elements.length) {
                return elements;
            }

            return elements
                .map(a => [Math.random(), a])
                .sort((a, b) => a[0] - b[0])
                .map(a => a[1]);
        }

        const childNodes = [...slider.getElementsByClassName('swiper-slide')];
        const swiperWrapper = slider.getElementsByClassName('swiper-wrapper')[0];
        randomizeOrder(childNodes).forEach(element => swiperWrapper.appendChild(element));

        const options = mergeSettings({
            typeSettings: {
                fadeEffect: {
                    crossFade: true
                },
                speed: 1500,
                loop: true,
                autoplay: {
                    enabled: true,
                    delay: 10000
                }
            },
            settings,
            nummberOfSlides
        });

        new Swiper(slider, options);
    }
};

export default type;
